import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { ForgotPassword } from '../../components/loginParts/ForgotPassword';
import { useAppDispatch } from '../../hooks/redux';
import { LoginRouteNames } from '../../models/Common';
import { authSlice } from '../../store/reducers/AuthSlice';

const ForgotPasswordPage = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const { setFormError } = authSlice.actions;

  const handleLink = useCallback(
    (link: LoginRouteNames) => {
      dispatch(setFormError(null));
      history.push(`${link}`);
    },
    [history],
  );

  const handleBack = () => {
    dispatch(setFormError(null));
    history.goBack();
  };

  return (
    <div className="login-page page">
      <div className="login-page__container container">
        <ForgotPassword handleBack={handleBack} handleLink={handleLink} />
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
